<div class="flex footer">
  <div class="container flex items-center flex-auto">
    <a class="flex-none action"
       color="primary"
       href="//1.envato.market/0vkRO"
       id="get-vex"
       mat-flat-button>
      <mat-icon class="icon-sm ltr:mr-2 rtl:ml-2" svgIcon="mat:shopping_bag"></mat-icon>
      <span>Get Vex (Angular 14+)</span>
    </a>
    <div class="hidden font-medium ltr:ml-4 rtl:mr-4 sm:block">
      Vex - Angular 14+ Material Design Admin Template - Save 100s of hours designing and coding
    </div>
  </div>
</div>
